/**
 * Created by mzietek on 2016-11-24.
 */

(function (angular) {
    'use strict';

    angular
        .module("repairforms.constant.module")
        .constant("DeliveryOptions", DeliveryOptions());

    function DeliveryOptions() {

        return {
            getOptions : getOptions
        };

        function getOptions() {
            return {
                SAME_ADDRESS_DELIVERY      : "same_address_delivery",
                DIFFERENT_ADDRESS_DELIVERY : "different_address_delivery",
                COURIER_DELIVERY           : "courier_delivery"
            };
        }
    }

})(angular);